import React from 'react';

function IconUpdateSvg() {
  return (
    <svg
      width="95"
      height="79"
      viewBox="0 0 95 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.1042 39.2383V74.4883"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M79.965 64.2679C83.7851 62.1853 86.8029 58.8898 88.542 54.9017C90.2812 50.9135 90.6427 46.4597 89.5695 42.2432C88.4963 38.0268 86.0495 34.2878 82.6153 31.6164C79.1811 28.945 74.9551 27.4932 70.6042 27.4904H65.6692C64.4837 22.9049 62.2741 18.6479 59.2065 15.0393C56.1389 11.4307 52.2932 8.56445 47.9584 6.65609C43.6237 4.74772 38.9127 3.84686 34.1797 4.02125C29.4466 4.19563 24.8147 5.44072 20.6322 7.6629C16.4496 9.88508 12.8252 13.0265 10.0315 16.8511C7.23777 20.6756 5.34742 25.0837 4.50255 29.744C3.65769 34.4043 3.88029 39.1954 5.15363 43.7573C6.42697 48.3192 8.71791 52.533 11.8542 56.082"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.7709 54.9049L47.1042 39.2383L31.4376 54.9049"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconUpdateSvg;
